import { render } from "./Currencies.vue?vue&type=template&id=3b9f4282"
import script from "./Currencies.vue?vue&type=script&lang=js"
export * from "./Currencies.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Select/Currencies.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b9f4282"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b9f4282', __exports__)) {
    api.reload('3b9f4282', __exports__)
  }
  
  module.hot.accept("./Currencies.vue?vue&type=template&id=3b9f4282", () => {
    api.rerender('3b9f4282', render)
  })

}


export default __exports__